<div [ngStyle]="{'min-height':'60px'}">
    <div class="inline-block float-left">
        <h3 [ngStyle]="{'margin-top':'8px'}">
            {{Translate('Create Favourite')}}
        </h3>
    </div>
    <div class="inline-block float-right">
        <button mat-icon-button (click)="onNoClick()">
            <mat-icon aria-label="close">close</mat-icon>
        </button>
    </div>
</div>
<div>
    <form #favoriteForm="ngForm">
        <div class="form-group">
            <mat-checkbox [checked] ="SetDefault" class="example-margin"  (change)="changeCheckbox()">Set as Default</mat-checkbox>
          </div>

        <div class="form-group">
            <label for="name" [ngClass]="{'colorRed': !modelname.valid}">{{Translate('Name')}}*</label>
            <input type="text" class="form-control" id="name" pattern=".{3,250}" required [(ngModel)]="model.Name" name="name" #modelname="ngModel">
            <div [hidden]="modelname.valid || modelname.untouched"
                 class="fav-alert alert-danger">
                {{Translate('Name is required')}}
            </div>
        </div>

        <div class="form-group">
            <label for="background"> {{Translate('Background Colour')}} </label>
            <select class="form-control" id="background" required [(ngModel)]="model.BackgroundColor" name="backgroundcolor" #modelbackground="ngModel">
                <option *ngFor="let color of availableColors" [value]="color.Colour">{{color.Name}}</option>
            </select>
        </div>

        <div class="form-group">
            <label for="text"> {{Translate('Text Colour')}} </label>
            <select class="form-control" id="text" required [(ngModel)]="model.TextColor" #modeltext="ngModel" name="textcolor">
                <option *ngFor="let color of availableColors" [value]="color.Colour">{{color.Name}}</option>
            </select>
        </div>
        <label> {{Translate('Preview')}} </label>
        <div class="fav-preview-box">
            <a class="button" [ngStyle]="{'background-color':model.BackgroundColor}"><span class="button__text" [ngStyle]="{'color':model.TextColor}">{{model.Name}}</span></a>
        </div>
        <div>
            <a class="button button--primary" [class.button--disabled]="!favoriteForm.form.valid" (click)="submitDialog(favoriteForm.form.valid)">
                <i class="material-icons button__icon">check</i>
                <span *ngIf="operation == 1" class="button__text">{{Translate('Save')}}</span>
                <span *ngIf="operation == 2" class="button__text">{{Translate('Update')}}</span>
                <span *ngIf="operation == 3" class="button__text">{{Translate('Remove')}}</span>
            </a>
            <a class="button" (click)="onNoClick()">
                <span class="button__text">{{Translate('Cancel')}}</span>
            </a>
        </div>
    </form>
</div>
